import React from "react";

const CancelPathologyIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C3.576 0 0 3.576 0 8C0 12.424 3.576 16 8 16C12.424 16 16 12.424 16 8C16 3.576 12.424 0 8 0ZM8.0001 14.4C4.4721 14.4 1.6001 11.528 1.6001 8C1.6001 4.472 4.4721 1.6 8.0001 1.6C11.5281 1.6 14.4001 4.472 14.4001 8C14.4001 11.528 11.5281 14.4 8.0001 14.4ZM8 6.872L10.872 4L12 5.128L9.128 8L12 10.872L10.872 12L8 9.128L5.128 12L4 10.872L6.872 8L4 5.128L5.128 4L8 6.872Z"
        fill="#DADADA"
      />
    </svg>
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="20"
    //   height="20"
    //   viewBox="0 0 20 20"
    //   fill="none"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M10 0C4.47 0 0 4.47 0 10C0 15.53 4.47 20 10 20C15.53 20 20 15.53 20 10C20 4.47 15.53 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 8.59L13.59 5L15 6.41L11.41 10L15 13.59L13.59 15L10 11.41L6.41 15L5 13.59L8.59 10L5 6.41L6.41 5L10 8.59Z"
    //     fill="#DADADA"
    //   />
    // </svg>
  );
};

export default CancelPathologyIcon;
